/**
 * @deprecated
 */

import $ from 'jquery';

// export to window
window.$ = $;
window.jQuery = $;




// WEBPACK FOOTER //
// ./fe/web-career/src/js/windowExports.js